import { Injectable } from '@angular/core';
import { ModelNameService } from './model-name.service';
import * as Models from './models';

// Place to globally register all models
@Injectable({ providedIn: 'root' })
export class ModelRegistrationService {
  constructor(
    modelNameService: ModelNameService,
    // To help with merge conflicts while we're all here. Add in alphabetical order
    // A
    accountModelAccessor: Models.AccountModelAccessor,
    apiModelAccessor: Models.ApiModelAccessor,
    // B
    // C
    channelModelAccessor: Models.ChannelModelAccessor,
    chartModelAccessor: Models.ChartModelAccessor,
    colorPaletteModelAccessor: Models.ColorPaletteModelAccessor,
    // D
    dataSourceModelAccessor: Models.DataSourceModelAccessor,
    dataSourceSchemaUpdateModelAccessor: Models.DataSourceSchemaUpdateModelAccessor,
    dataSourceTableModelAccessor: Models.DataSourceTableModelAccessor,
    // E
    emailSubscriptionMembershipModelAccessor: Models.EmailSubscriptionMembershipModelAccessor,
    embedKeyModelAccessor: Models.EmbedKeyModelAccessor,
    explorationModelAccessor: Models.ExplorationModelAccessor,
    // F
    // G
    groupMembershipModelAccessor: Models.GroupMembershipModelAccessor,
    groupModelAccessor: Models.GroupModelAccessor,
    // H
    // I
    inviteModelAccessor: Models.InviteModelAccessor,
    // J
    // K
    // L
    libraryDefinitionModelAccessor: Models.LibraryDefinitionModelAccessor,
    // M
    // N
    // O
    orgModelAccessor: Models.OrgModelAccessor,
    // P
    pdfExportAccessor: Models.PdfExportModelAccessor,
    pinModelAccessor: Models.PinModelAccessor,
    preferenceModelAccessor: Models.PreferenceModelAccessor,
    pythonCellBatchRunModelAccessor: Models.PythonCellBatchRunModelAccessor,
    pythonCellModelAccessor: Models.PythonCellModelAccessor,
    pythonCellRunResultModelAccessor: Models.PythonCellRunResultModelAccessor,
    pythonCellRunModelAccessor: Models.PythonCellRunModelAccessor,
    pythonNotebookModelAccessor: Models.PythonNotebookModelAccessor,
    pythonSessionModelAccessor: Models.PythonSessionModelAccessor,
    pythonVisualizationModelAccessor: Models.PythonVisualizationModelAccessor,
    // Q
    queryRunModelAccessor: Models.QueryRunModelAccessor,
    queryTableModelAccessor: Models.QueryTableModelAccessor,
    queryModelAccessor: Models.QueryModelAccessor,
    // R
    reportFilterModelAccessor: Models.ReportFilterModelAccessor,
    reportModelAccessor: Models.ReportModelAccessor,
    reportPinModelAccessor: Models.ReportPinModelAccessor,
    reportRunEmailModelAccessor: Models.ReportRunEmailModelAccessor,
    reportRunModelAccessor: Models.ReportRunModelAccessor,
    reportRunSlackMessageModelAccessor: Models.ReportRunSlackMessageModelAccessor,
    reportScheduleModelAccessor: Models.ReportScheduleModelAccessor,
    reportSubscriptionModelAccessor: Models.ReportSubscriptionModelAccessor,
    reportThemeModelAccessor: Models.ReportThemeModelAccessor,
    resultModelAccessor: Models.ResultModelAccessor,
    // S
    searchModelAccessor: Models.SearchModelAccessor,
    slackAppModelAccessor: Models.SlackAppModelAccessor,
    slackSubscriptionMembershipModelAccessor: Models.SlackSubscriptionMembershipModelAccessor,
    spaceDetailModelAccessor: Models.SpaceDetailModelAccessor,
    spaceLinkModelAccessor: Models.SpaceLinkModelAccessor,
    spaceMembershipModelAccessor: Models.SpaceMembershipModelAccessor,
    spaceReportPinModelAccessor: Models.SpaceReportPinModelAccessor,
    spaceModelAccessor: Models.SpaceModelAccessor,
    starModelAccessor: Models.StarModelAccessor,
    // T
    tablePreviewModelAccessor: Models.TablePreviewModelAccessor,
    tableValidationModel: Models.TableValidationModelAccessor,
    tableModelAccessor: Models.TableModelAccessor
    // U
    // V
    // W
    // X
    // Y
    // Z
  ) {
    // As we migrate Models to Angular2, we can register them here.
    // Previously, in AngularJs, these were registered in a module.run
    // modelNameService.put(modelAccessor.name, modelAccessor)

    // To help with merge conflicts while we're all here. Add in alphabetical order
    // A
    modelNameService.put(accountModelAccessor.name, accountModelAccessor);
    modelNameService.put(apiModelAccessor.name, apiModelAccessor);
    // B
    // C
    modelNameService.put(channelModelAccessor.name, channelModelAccessor);
    modelNameService.put(chartModelAccessor.name, chartModelAccessor);
    modelNameService.put(colorPaletteModelAccessor.name, colorPaletteModelAccessor);
    // D
    modelNameService.put(dataSourceModelAccessor.name, dataSourceModelAccessor);
    modelNameService.put(dataSourceSchemaUpdateModelAccessor.name, dataSourceSchemaUpdateModelAccessor);
    modelNameService.put(dataSourceTableModelAccessor.name, dataSourceTableModelAccessor);
    // E
    modelNameService.put(emailSubscriptionMembershipModelAccessor.name, emailSubscriptionMembershipModelAccessor);
    modelNameService.put(embedKeyModelAccessor.name, embedKeyModelAccessor);
    modelNameService.put(explorationModelAccessor.name, explorationModelAccessor);
    // F
    // G
    modelNameService.put(groupMembershipModelAccessor.name, groupMembershipModelAccessor);
    modelNameService.put(groupModelAccessor.name, groupModelAccessor);
    // H
    // I
    modelNameService.put(inviteModelAccessor.name, inviteModelAccessor);
    // J
    // K
    // L
    modelNameService.put(libraryDefinitionModelAccessor.name, libraryDefinitionModelAccessor);
    // M
    // N
    // O
    modelNameService.put(orgModelAccessor.name, orgModelAccessor);
    // P
    modelNameService.put(pdfExportAccessor.name, pdfExportAccessor);
    modelNameService.put(pinModelAccessor.name, pinModelAccessor);
    modelNameService.put(preferenceModelAccessor.name, preferenceModelAccessor);
    modelNameService.put(pythonCellBatchRunModelAccessor.name, pythonCellBatchRunModelAccessor);
    modelNameService.put(pythonCellModelAccessor.name, pythonCellModelAccessor);
    modelNameService.put(pythonCellRunResultModelAccessor.name, pythonCellRunResultModelAccessor);
    modelNameService.put(pythonCellRunModelAccessor.name, pythonCellRunModelAccessor);
    modelNameService.put(pythonNotebookModelAccessor.name, pythonNotebookModelAccessor);
    modelNameService.put(pythonSessionModelAccessor.name, pythonSessionModelAccessor);
    modelNameService.put(pythonVisualizationModelAccessor.name, pythonVisualizationModelAccessor);
    // Q
    modelNameService.put(queryRunModelAccessor.name, queryRunModelAccessor);
    modelNameService.put(queryTableModelAccessor.name, queryTableModelAccessor);
    modelNameService.put(queryModelAccessor.name, queryModelAccessor);
    // R
    modelNameService.put(reportFilterModelAccessor.name, reportFilterModelAccessor);
    modelNameService.put(reportModelAccessor.name, reportModelAccessor);
    modelNameService.put(reportPinModelAccessor.name, reportPinModelAccessor);
    modelNameService.put(reportScheduleModelAccessor.name, reportScheduleModelAccessor);
    modelNameService.put(reportRunEmailModelAccessor.name, reportRunEmailModelAccessor);
    modelNameService.put(reportRunModelAccessor.name, reportRunModelAccessor);
    modelNameService.put(reportRunSlackMessageModelAccessor.name, reportRunSlackMessageModelAccessor);
    modelNameService.put(reportSubscriptionModelAccessor.name, reportSubscriptionModelAccessor);
    modelNameService.put(reportThemeModelAccessor.name, reportThemeModelAccessor);
    modelNameService.put(resultModelAccessor.name, resultModelAccessor);
    // S
    modelNameService.put(searchModelAccessor.name, searchModelAccessor);
    modelNameService.put(slackAppModelAccessor.name, slackAppModelAccessor);
    modelNameService.put(slackSubscriptionMembershipModelAccessor.name, slackSubscriptionMembershipModelAccessor);
    modelNameService.put(spaceDetailModelAccessor.name, spaceDetailModelAccessor);
    modelNameService.put(spaceLinkModelAccessor.name, spaceLinkModelAccessor);
    modelNameService.put(spaceMembershipModelAccessor.name, spaceMembershipModelAccessor);
    modelNameService.put(spaceReportPinModelAccessor.name, spaceReportPinModelAccessor);
    modelNameService.put(spaceModelAccessor.name, spaceModelAccessor);
    modelNameService.put(starModelAccessor.name, starModelAccessor);
    // T
    modelNameService.put(tablePreviewModelAccessor.name, tablePreviewModelAccessor);
    modelNameService.put(tableValidationModel.name, tableValidationModel);
    modelNameService.put(tableModelAccessor.name, tableModelAccessor);
    // U
    // V
    // W
    // X
    // Y
    // Z
  }
}
